import tabs from "./he/tabs";
import pages from "./he/pages";
import appLauncher from "./he/appLauncher";
import apps from "./he/apps";
import auditLog from "./he/auditLog";
import roadmapPage from "./he/roadmapPage";
import ceoQueue from "./he/ceoQueue";
import common from "./he/common";
import speedDial from "./he/speedDial";
import smartBar from "./he/smartBar";
import auth from "./he/auth";
import settings from "./he/settings";
import sidebar from "./he/sidebar";
import tray from "./he/tray";
import shellPrefs from "./he/shellPrefs";
import userMenu from "./he/userMenu";
import downloads from "./he/downloads";
import brand from "./he/brand";
import contextMenu from "./he/contextMenu";
import elementLabels from "./he/elementLabels";
import elementDescriptions from "./he/elementDescriptions";
import guide from "./he/guide";
import folders from "./he/folders";
import fieldLibrary from "./he/fieldLibrary";
import canvas from "./he/canvas";
import storyMap from "./he/storyMap";
import health from "./he/health";
import dashboardHome from "./he/dashboardHome";
import hub from "./he/hub";
import boardroom from "./he/boardroom";
import documentsPage from "./he/documentsPage";
import exportNs from "./he/export";
import docControl from "./he/docControl";
import docTemplates from "./he/docTemplates";
import docFields from "./he/docFields";
import fieldConfig from "./he/fieldConfig";
import emailTemplates from "./he/emailTemplates";
import emailDesigner from "./he/emailDesigner";
import relativeTime from "./he/relativeTime";
import layers from "./he/layers";
import home from "./he/home";
import admin from "./he/admin";
import audit from "./he/audit";
import widgets from "./he/widgets";
import gallery from "./he/gallery";
import designSystem from "./he/designSystem";
import projectDetail from "./he/projectDetail";
import functionalMap from "./he/functionalMap";
import architecturePage from "./he/architecturePage";
import planPage from "./he/planPage";
import automations from "./he/automations";
import rss from "./he/rss";
import editor from "./he/editor";
import aiHub from "./he/aiHub";
import bottomBar from "./he/bottomBar";
import comms from "./he/comms";
import email from "./he/email";
import pwa from "./he/pwa";
import entities from "./he/entities";
import wiki from "./he/wiki";
import toolkit from "./he/toolkit";
import iconPicker from "./he/iconPicker";
import grid from "./he/grid";
import slides from "./he/slides";
import matching from "./he/matching";
import contractor from "./he/contractor";
import importEngine from "./he/importEngine";
import gmail from "./he/gmail";
import googleCalendar from "./he/googleCalendar";
import courses from "./he/courses";
import workspaceSwitcher from "./he/workspaceSwitcher";
import knowledge from "./he/knowledge";

export const he = { tabs, pages, appLauncher, apps, auditLog, roadmapPage, ceoQueue, common, speedDial, smartBar, auth, settings, sidebar, tray, shellPrefs, userMenu, downloads, brand, contextMenu, elementLabels, elementDescriptions, guide, folders, fieldLibrary, canvas, storyMap, health, dashboardHome, hub, boardroom, documentsPage, export: exportNs, docControl, docTemplates, docFields, fieldConfig, emailTemplates, emailDesigner, relativeTime, layers, home, admin, audit, widgets, gallery, designSystem, projectDetail, functionalMap, architecturePage, planPage, automations, rss, editor, aiHub, bottomBar, comms, email, pwa, entities, wiki, toolkit, iconPicker, grid, slides, matching, contractor, importEngine, gmail, googleCalendar, courses, workspaceSwitcher, knowledge } as const;
